<template>
  <div
    class="chart"
    ref="chart"
    :style="{ height: height, width: width }"
  ></div>
</template>

<script>
export default {
  name: 'Chart',
  data() {
    return {
      chart: null,
    };
  },
  props: {
    // 传配置项option
    option: {
      type: Object,
      default() {
        return {};
      },
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '400px',
    },
  },
  watch: {
    option() {
      if (this.chart) {
        this.chart.setOption(this.option); // 设置对应配置项
      }
    },
  },
  mounted() {
    this.chart = this.$echarts.init(this.$refs.chart); // 初始化echarts
    this.chart.setOption(this.option); // 设置对应配置项
    // 当窗口大小改变 echarts重置大小
    window.addEventListener('resize', () => {
      this.chart.resize();
    });
  },
};
</script>

<style lang="scss" scoped>
</style>




// WEBPACK FOOTER //
// src/echarts/chart.vue